import { render, staticRenderFns } from "./TicketsResponseDialog.vue?vue&type=template&id=6c24fec3&"
import script from "./TicketsResponseDialog.vue?vue&type=script&lang=js&"
export * from "./TicketsResponseDialog.vue?vue&type=script&lang=js&"
import style0 from "./TicketsResponseDialog.vue?vue&type=style&index=0&id=6c24fec3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports